module.exports = __webpack_public_path__ + "static/img/RSG2-24V5A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RSG2-24V5A.png
// module id = NkcL
// module chunks = 0